import { render, staticRenderFns } from "./collapseHeader.vue?vue&type=template&id=eeb234cc&scoped=true"
import script from "./collapseHeader.vue?vue&type=script&lang=js"
export * from "./collapseHeader.vue?vue&type=script&lang=js"
import style0 from "./collapseHeader.vue?vue&type=style&index=0&id=eeb234cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb234cc",
  null
  
)

export default component.exports